import React, { PureComponent, Fragment } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import history from '../../history';
import { logout } from '../../Store/actions/loginActions';
import { newPasswordResetRequest } from '../../Store/actions/newPasswordResetActions';
import { addFlashMessage } from '../../Store/actions/flashMessages';
import NewPasswordResetForm from './NewPasswordResetForm';
import { AJAX_REQUEST, sentryErrorLog } from '../../Constants/AppConstants';

class NewPasswordReset extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            loading: true
        }
        if (this.props.isAuthenticated) {
            AJAX_REQUEST("POST", "operator/details", {}).then(results => {

                // Sentry Log create
                sentryErrorLog(results);

                const response = results.response;
                if (parseInt(response.code) === 1000) {
                    history.push('/');
                } else {
                    this.props.logout();
                }
            });
        }
        document.title = "Change Password - ALAN Live Chat Operator";
    }

    changeHandler = (e) => {
        [e.target.name] = e.target.value;
    }

    componentDidMount() {
        document.querySelector("body").scrollIntoView();
        this.setState({
            loading: false
        });
    }

    render() {
        const { newPasswordResetRequest, addFlashMessage } = this.props;
        return (
            <Fragment>
                {
                    this.state.loading ?
                        <div className="loading"></div>
                        :
                        <React.Fragment>
                            <div className="container login_container">
                                <div className="row login_row">
                                    <div className="col-md-12">
                                        <main className="">
                                            <div className="user_login">
                                                <h2 className="montserrat">Change Password</h2>
                                                <NewPasswordResetForm newPasswordResetRequest={newPasswordResetRequest} addFlashMessage={addFlashMessage} />
                                            </div>
                                        </main>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                }
            </Fragment>
        );
    }
}

NewPasswordReset.propTypes = {
    newPasswordResetRequest: PropTypes.func.isRequired,
    addFlashMessage: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    logout: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.isAuthenticated
    }
}

export default connect(mapStateToProps, { newPasswordResetRequest, addFlashMessage, logout })(NewPasswordReset);